import mixpanel from "mixpanel-browser";

// projekt RAKS.NET
const MixpanelToken = "75bb9e9f90bdd9c103a7a68a4cc9c310";

export const MIXPANEL_EVENT_ZALOZONO_KONTO = "Założono konto";
export const MIXPANEL_EVENT_ZALOGOWANO = "Zalogowano";
export const MIXPANEL_EVENT_POTWIERDZONO_KONTO = "Potwierdzono konto";
export const MIXPANEL_EVENT_USUNIETO_KONTO = "Usunięto konto";

export const mixpanelService = {
  start,
  login,
  uaktualnijProfilUzytkownika,
  rejestrujZdarzenie,
};

function develop() {
  return (
    window.location.host.includes("localhost") ||
    window.location.host.includes("staging")
  );
}

function start() {
  if (!develop() && mixpanel) {
    mixpanel.init(MixpanelToken);
  }
}

function login(email: string) {
  if (!develop() && mixpanel) {
    mixpanel.identify(email);
  }
}

function uaktualnijProfilUzytkownika(email: string, properties: any) {
  if (!develop() && mixpanel && mixpanel.people) {
    mixpanel.people.set(properties);
    mixpanel.people.set_once(email, { $created: new Date() });
  }
}

function rejestrujZdarzenie(nazwaZdarzenia: string, properties: any) {
  if (!develop() && mixpanel) mixpanel.track(nazwaZdarzenia, properties);
}
